/** Una serie sin acciones (total nulo o 0) no se puede elegir en ningún desplegable. */
export function serieTieneAcciones(serie: { totalShares?: number | null } | null | undefined): boolean {
  return (serie?.totalShares ?? 0) > 0;
}
